module.exports = __webpack_public_path__ + "img/珍银面膜--OK_03.fc15055d.jpg";